function handleZoom(val, dir, canvasElem, activeDisplay, setZoomNumber, zoomNumber, setZoomRatio) {

    let elem = document.getElementById('canvasForm');

    let cHeight = elem.offsetHeight;
    let cWidth = elem.offsetWidth;
    let nHeight = cHeight + val;
    let ar = cWidth/cHeight;
    let nWidth = Math.round(nHeight*ar);
    let ratio;
    let newZoomNumber = zoomNumber;
    // elem.style.height = nHeight + "px";
    // elem.style.width = nWidth + "px";


  
    // if (aspectRatio === 1) {
    //   ratio = nHeight/1080
    // }
    // if (aspectRatio === 2) {
    //   ratio = nHeight/820
    // }
  
    (dir === 'in') && (newZoomNumber+=0.1);
    if (dir === 'out') {
        let r = zoomNumber - 0.1
        if (r === 0) {
          r = 1
        }
        newZoomNumber = r;
    }
    if ((newZoomNumber<=1.8)&&(newZoomNumber > 0.2)) {
      setZoomNumber(newZoomNumber);
      console.log('handleZoom', newZoomNumber);
    } 
    
    
    // setZoomRatio(ratio)
    
  }

  export {handleZoom} ;